import './scrollPatch';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/app.css';
import RootComponent from './components/RootComponent';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>
);
